import { ThemeProvider } from '@fluentui/react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import * as React from 'react';
import { corptaxFluentUiTheme } from '../components/utils/corptaxFluentUiTheme';
import { BaseThemeSettings } from '../data-types/styles/BaseTheme';
import { ICorptaxThemeSettings } from '../data-types/styles/ICorptaxThemeSettings';

const defaultTheme: ICorptaxThemeSettings = corptaxFluentUiTheme;

export const CorptaxThemeContext = React.createContext<BaseThemeSettings | null>(null);

export function CorptaxThemeProvider<T extends BaseThemeSettings>(props: { children: React.ReactNode; theme?: Partial<T> }) {
    const themeSettings = Object.assign({}, defaultTheme, props.theme);

    return (
        <CorptaxThemeContext.Provider value={themeSettings}>
            <ThemeProvider theme={themeSettings}>
                <StyledThemeProvider theme={themeSettings}>{props.children}</StyledThemeProvider>
            </ThemeProvider>
        </CorptaxThemeContext.Provider>
    );
}
